<script>
    import SdfXuanhao from "../xuanhao/SdfXuanhao.svelte";
    import SdfShow from "../showball/SdfShow.svelte";
    export let value;
    export let key;
    export let choose_panel;
    export let action_id;
</script>

{#if choose_panel == key}
    <SdfXuanhao bind:value={value} bind:key={key} bind:choose_panel={choose_panel} bind:action_id={action_id}/>
{:else}
    <SdfShow bind:value={value} bind:key={key} bind:choose_panel={choose_panel} bind:action_id={action_id} on:del/>
{/if}

<style>
    
</style>
